import { Link } from 'react-router-dom'
import React from 'react'

const HistoryBtnPanel: React.FC = () => {
  return (
    <Link
      to={`/history`}
      className="historyBtnPanel bg-primary flex flex-row flex-nowrap items-center justify-between text-white gap-1 p-2"
      style={{ minHeight: '68px', borderRadius: '8px' }}
    >
      <span className="font-semibold text-base leading-tight">История платежей</span>
      <span className="mr-2">
        <i className="fas fa-file-alt text-lg"></i>
      </span>
    </Link>
  )
}

export default HistoryBtnPanel
